import { GetterTree } from 'vuex'
import VersioningState from '../types/VersioningState'

export const getters: GetterTree<VersioningState, any> = {
  getVersion: state => state.version,
  getReadyToUpdate: state => state.readyToUpdate,
  getUi: state => state.ui
}
